import { render } from "./AnimeCard.vue?vue&type=template&id=19f735a0&scoped=true"
import script from "./AnimeCard.vue?vue&type=script&lang=js"
export * from "./AnimeCard.vue?vue&type=script&lang=js"

import "./AnimeCard.vue?vue&type=style&index=0&id=19f735a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f735a0"]])

export default __exports__